// STUDIO-SELF-NOTICE-LIBRARY-SHARE-1 · Galaxy Studio 저장 공지 목록 — 기존 NOTICE 보관함(GET /seller/notices) 조회 전용 REUSE.
// 선택 시 TEST 공유 세션 live_notice 만 변경 (보관함·운영 공지 데이터 미변경). notice_id 유지 → 후속 리모컨 연결용.
import React from 'react';
import useNoticeLibrary from '@/hooks/useNoticeLibrary';

export const StudioNoticeLibraryList = ({ activeId, onSelect, current = null, onClear = null }) => {
  const { items, loading } = useNoticeLibrary();
  const list = items.filter((n) => (n.text || '').trim());
  return (
    <div className="space-y-1.5" data-testid="studio-notice-library">
      <p className="text-[11px] font-black text-gray-600 dark:text-gray-300 flex items-center gap-2">저장된 공지 · {list.length}
        {onClear && current && (
          <button type="button" onClick={onClear} className="ml-auto px-2 py-0.5 rounded-full border border-[#FF3B30] text-[#FF3B30] text-[10px] font-black"
                  data-testid="studio-notice-library-clear">현재 공지 내리기</button>
        )}
      </p>
      {loading && <p className="text-[11px] text-gray-400">불러오는 중…</p>}
      {!loading && !list.length && (
        <p className="text-[11px] text-gray-400" data-testid="studio-notice-library-empty">PC NOTICE 보관함에 저장된 공지가 없어요.</p>
      )}
      <div className="max-h-40 overflow-y-auto space-y-1">
        {list.map((n) => {
          const on = activeId === n.notice_id;
          return (
            <button key={n.notice_id} type="button" onClick={() => onSelect(n)}
                    className={`w-full text-left rounded-lg border px-2 py-1.5 flex items-start gap-2 ${on ? 'border-[#FF3B30] bg-[#FF3B30]/5' : 'border-black/10 dark:border-white/10'}`}
                    data-testid={`studio-notice-library-item-${n.notice_id}`} data-active={on ? '1' : '0'}>
              <span className="flex-1 min-w-0 text-[11px] break-words line-clamp-2">{n.text}</span>
              <span className={`shrink-0 text-[10px] font-black ${on ? 'text-[#FF3B30]' : 'text-gray-500'}`}>{on ? '표시 중' : '표시'}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default StudioNoticeLibraryList;
